module.exports = __webpack_public_path__ + "static/media/edit_white20aee9d4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/edit_white.svg
// module id = 1228
// module chunks = 0